import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, delay, map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  // _liveApiUrl: any = this.authService._liveApiUrl;
     get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  port = environment.port;
  apiUrl = environment.apiUrl;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService
  ) {}

  private _plans = new BehaviorSubject<object[]>([]);
  private plansData: { plans: object[] } = { plans: [] };

  private _planCount = new BehaviorSubject<object[]>([]);
  private planCountData: { planCount: object[] } = { planCount: [] };

  getPlans(): Observable<any[]> {
    return this._plans.asObservable();
  }

  getPlanCount(): Observable<any[]> {
    return this._planCount.asObservable();
  }
  getNotificationCount(): Observable<any[]> {
    return this._planCount.asObservable();
  }
  getLS(k: any) {
    return localStorage.getItem(k);
  }
  planList(id?: Number) {
    let orgDomain = this.getLS('org_domain');
    // if(orgDomain != null){
    //   this._liveApiUrl =  orgDomain + ':' + this.port
    // }
    let tail = '';
    if (id) {
      tail = `${id}`;
    }

    this.http
      .get<any>(`${this._liveApiUrl}/tenant/plan/${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {

          this.plansData.plans = data;
          this._plans.next(Object.assign({}, this.plansData).plans);
          this.planCount();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  // planList1(plan_type?: any) {
  //   let tail = '';
  //   let queryParams = '';
  
  //   // If plan_type is provided, add it to the query params
  //   if (plan_type) {
  //     queryParams = `?plan_type=${plan_type}`;
  //   }
  
  //   // Make the API call with the potential plan_type query param
  //   this.http
  //     .get<any>(`${this._liveApiUrl}/tenant/plan${queryParams}`)
  //     .pipe(
  //       map((data) => data),
  //       catchError(this.authService.handleError)
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         if (this.authService.resultCodeError(data)) {
  //           return;
  //         }
  
  //         this.plansData.plans = data;
  //         this._plans.next(Object.assign({}, this.plansData).plans);
  //         this.planCount();
  //       },
  //       (error) => {
  //         this.authService.dataError(error);
  //       }
  //     );
  // }
 planList1(plan_type?: any) {
  let queryParams = '';
  let planCategory = '';

  // 🌟 Always send plan_type as it is
  const finalPlanType = plan_type;

  // 🌟 If Default → pick sub_plan_type from LS → and make plan_category
  if (plan_type === 'Default') {
    const subPlanType = localStorage.getItem('sub_plan_type'); 
    // Example: Shipping / Receiving

    if (subPlanType) {
      planCategory =
        subPlanType === 'Shipping'
          ? 'shipping'
          : subPlanType === 'Receiving'
          ? 'receiving'
          : '';
    }
  }

  // 🌟 Build query params
  queryParams = `?plan_type=${finalPlanType}`;

  // Add plan_category only if available
  if (planCategory) {
    queryParams += `&plan_category=${planCategory}`;
  }

  // 🌟 API Call
  this.http
    .get<any>(`${this._liveApiUrl}/tenant/plan${queryParams}`)
    .pipe(
      map((data) => data),
      catchError(this.authService.handleError)
    )
    .subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) return;

        this.plansData.plans = data;
        this._plans.next(Object.assign({}, this.plansData).plans);
        this.planCount();
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
}



  planAdd(form: any) {
    let orgDomain = this.getLS('org_domain');
    // if(orgDomain != null){
    //   this._liveApiUrl =  orgDomain + ':' + this.port
    // }
    return this.http.post<any>(`${this._liveApiUrl}/tenant/plan/`, form).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.authService.handleError)
    );
  }

  planEdit(id: Number, form: any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/tenant/plan/${id}/`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }

  planDelete(id: Number) {
    return this.http.delete<any>(`${this._liveApiUrl}/tenant/plan/${id}`);
  }

  planCount() {
    this.http
      .get<any>(`${this._liveApiUrl}/tenant/plan-count/`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {

          this.planCountData.planCount = data;
          this._planCount.next(Object.assign({}, this.planCountData).planCount);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  notificationCount() {
    return this.http
      .get<any>(`${this.authService._liveApiUrl}/notification/notification-count/`)
  }
  notificationShippingCount() {
  return this.http.get<any>(
    `${this.authService._liveApiUrl}/notification/notification-count/`,
    { params: { is_shipped_admin: true } }
  );
}
   notificationReciverCount() {
  return this.http.get<any>(
    `${this.authService._liveApiUrl}/notification/notification-count/`,
    { params: { is_receiving_admin: true } }
  );
  }
  notificationList() {
    let tail = '?page=all'
    return this.http
      .get<any>(`${this.authService._liveApiUrl}/notification/user-notification/${tail}`)
  }
  notificationListShipping() {
  return this.http.get<any>(
    `${this.authService._liveApiUrl}/notification/user-notification/`,
    { params: {
        is_shipped_admin: true,
        page: 'all'
      } }
  );
}

notificationListReciving() {
  return this.http.get<any>(
    `${this.authService._liveApiUrl}/notification/user-notification/`,
    { params: { is_receiving_admin: 'true' ,page: 'all'} } // yaha false bhejna hoga agar Receiving ke liye hai
  );
}

  notificationListSuperAdmins() {
    let tail = '?page=all'
    return this.http
      .get<any>(`${this.authService._liveApiUrl}/notification/user-notification/${tail}`)
  }
  clearNotification(formData:any) {
    return this.http
      .put<any>(`${this.authService._liveApiUrl}/notification/clear-notification/`, formData)
  }
  clearNotificationSuperAdmin(formData:any) {
    return this.http
      .put<any>(`${this.authService._liveApiUrl}/notification/clear-notification/`, formData)
  }
  deletNotification(formData:any) {
    return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/clear-notification/`, formData)
  }
  deleteNotificationSuperAdmin(formData:any){
    return this.http
    .post<any>(`${this.authService._liveApiUrl}/notification/clear-notification/`, formData)
  }
  sendNotificationToGroup(formData:any,driver:any) {
    if(driver){
      return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-driver-notification/`,formData)
    }
    else{
      return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-notification/`,formData)
    }
  
  }
  sendNotificationToDriverCustomer(formData:any) {
    return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-order-notification/`,formData)
  }

  getAdminSentNotificationList(tabName: string, searchVal: string, page: any) {
    let tail = '';
    let params = new URLSearchParams();

    if (params) {
        // Check if tabName is 'all' and set it to an empty string
        if (tabName === 'all') {
            tabName = '';
        }

        // Set notif_type only if tabName is not empty
        if (tabName && tabName.length > 0) {
            params.set('notif_type', tabName);
        }

        // Set search_text if searchVal is provided
        if (searchVal && searchVal.length > 0) {
            params.set('search_text', searchVal);
        }

        // Set page if provided
        if (page) {
            params.set('page', page + 1);
        }
    }

    // Build the query string if there are parameters to include
    if (tabName || searchVal || page) {
        tail += `?` + params.toString();
    }

    return this.http
        .get<any>(`${this.authService._liveApiUrl}/notification/admin-notification-listing/${tail}`)
        .pipe(
            map((data) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
}

  clearAdminNotification(formData:any){
    return this.http
      .put<any>(`${this.authService._liveApiUrl}/notification/clear-admin-notification/`,formData)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
  }
  clearAllAdminNotification(){
    return this.http
      .put<any>(`${this.authService._liveApiUrl}/notification/clear-admin-notification/all/`,{})
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
  }
   clearAllCustomerNotification() {
  return this.http
    .put<any>(
      `${this.authService._liveApiUrl}/notification/clear-admin-notification/all/?notif_type=Customer`,
      {}
    )
    .pipe(
      map((data) => data),
      catchError(this.authService.handleError)
    );
}

 clearAllDriverNotification() {
  return this.http
    .put<any>(
      `${this.authService._liveApiUrl}/notification/clear-admin-notification/all/?notif_type=Driver`,
      {}
    )
    .pipe(
      map((data) => data),
      catchError(this.authService.handleError)
    );
}

}
